import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map } from 'rxjs';
import { BusStructure, ClientType, MonthBal, StaffDdl, clientDdlResponseModel, countryDdlResponseModel, stateDdlResponseModel } from '../models/clients';
import { apiEndpoints } from 'src/app/shared/enums/api-endpoints';
import { cost_ddl, custom_field_type, custom_field_type_ddl, custom_field_usage, paymenttermsReposeModel } from '../../organization/models/client-type';

@Injectable({
  providedIn: 'root'
})
export class DdlService {

  constructor(
    private httpClient: HttpClient,
  ) { }

  getstaff_ddl(): Observable<StaffDdl> {
    return this.httpClient.get<StaffDdl>(apiEndpoints.staff_ddl).pipe(
      map((response: StaffDdl) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getMonth_balance(pagination: any): Observable<MonthBal> {
    return this.httpClient.get<MonthBal>(apiEndpoints.balance_month + `?page=${pagination.page}&limit=${pagination.limit}`).pipe(
      map((response: MonthBal) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getbusiness_structure(pagination:any): Observable<BusStructure> {
    return this.httpClient.get<BusStructure>(apiEndpoints.business_structure + `?page=${pagination.page}&limit=${pagination.limit}`).pipe(
      map((response: BusStructure) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getClient_Type(pagination:any): Observable<ClientType> {
    return this.httpClient.get<ClientType>(apiEndpoints.ddl_client_type + `?page=${pagination.page}&limit=${pagination.limit}`).pipe(
      map((response: ClientType) =>
        response
      )
    );
  }

  getClientDdl(pagination:any): Observable<clientDdlResponseModel>{
    return this.httpClient.get<clientDdlResponseModel>(apiEndpoints.client_ddl + `?page=${pagination.page}&limit=${pagination.limit}`).pipe(
      map((response: clientDdlResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getStateDdl(country_id: any, pagination:any): Observable<stateDdlResponseModel> {
    return this.httpClient.get<stateDdlResponseModel>(apiEndpoints.state_ddl + country_id + '/' + `?page=${pagination.page}&limit=${pagination.limit}`).pipe(
      map((response:stateDdlResponseModel ) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }
  getCountryDdl(pagination:any): Observable<countryDdlResponseModel>{
    return this.httpClient.get<countryDdlResponseModel>(apiEndpoints.country_ddl + `?page=${pagination.page}&limit=${pagination.limit}`).pipe(
      map((response: countryDdlResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getAddresTypeDdl(pagination:any): Observable<any>{
    return this.httpClient.get<any>(apiEndpoints.address_type + `?page=${pagination.page}&limit=${pagination.limit}`).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }


  getcustom_field_usageDdl(pagination:any): Observable<custom_field_usage>{
    return this.httpClient.get<custom_field_usage>(apiEndpoints.custom_field_usage + `?page=${pagination.page}&limit=${pagination.limit}`).pipe(
      map((response: custom_field_usage) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getcustom_field_typeDdl(pagination:any): Observable<custom_field_type>{
    return this.httpClient.get<custom_field_type>(apiEndpoints.custom_field_type + `?page=${pagination.page}&limit=${pagination.limit}`).pipe(
      map((response: custom_field_type) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getRateSourceDdl(pagination:any): Observable<any>{
    return this.httpClient.get<any>(apiEndpoints.timesheet_rate_source + `?page=${pagination.page}&limit=${pagination.limit}`).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getColumnFilters(module: string): Observable<any> {
    return this.httpClient.get<any>(apiEndpoints.get_user_organization_filter + `?module=${module}`).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  setColumnFilters(value: any): Observable<any> {
    return this.httpClient.post<any>(apiEndpoints.set_user_organization_filter, value).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }
}
